import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Menu,
  ChevronLeft,
  Home,
  FileText,
  Layers,
  RefreshCw,
  Settings,
  Users,
  Calendar,
} from 'lucide-react';
import DicomSenderAll from '../bottom/SendDicomAll';

const Sidebar = ({
  rolUsuario,
  onFilterToggle,
  onNavigation,
  onToggleTemplate,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const sidebarWidthClass = isOpen ? 'w-64' : 'w-20';

  // asideClasses: matches RisWorklist structurally + fixed behavior
  const asideClasses = `bg-black bg-gradient-to-t from-secondary-dark border-r border-secondary-dark fixed ${isOpen ? 'top-0 h-screen' : 'top-12 h-[calc(100vh-3rem)]'} left-0 z-40 flex flex-col transition-all duration-300 ${sidebarWidthClass} -translate-x-full sm:translate-x-0`;

  const getButtonClass = (isActive) => `w-full flex items-center px-4 py-3 mx-2 rounded-lg transition-all duration-200 ${
    isActive 
      ? 'bg-primary-light/10 text-primary-light border-r-4 border-primary-light shadow-sm' 
      : 'text-gray-400 hover:text-white hover:bg-secondary-dark border-transparent border-r-4'
  }`;

  const renderLink = (label, IconComponent, onClick, path = '') => {
    // If it's a navigation action, compare with current path
    const isActive = path ? location.pathname === path : false;
    
    return (
      <button
        onClick={onClick}
        title={!isOpen ? label : undefined}
        className={getButtonClass(isActive)}
        style={{ width: 'calc(100% - 16px)' }}
      >
        <IconComponent className={`w-5 h-5 ${isActive ? 'text-primary-light' : 'text-gray-400'} flex-shrink-0 transition-colors`} />
        {isOpen && (
          <span className="ml-3 text-sm font-medium whitespace-nowrap overflow-hidden">
            {label}
          </span>
        )}
      </button>
    );
  };

  return (
    <aside className={asideClasses} aria-label="Sidenav">
      <div className="flex flex-col h-full overflow-y-auto overflow-x-hidden custom-scrollbar">
        {/* TOP HEADER */}
        <div className="h-16 flex items-center justify-between px-4 border-b border-secondary-dark/50 flex-shrink-0">
          {isOpen && <span className="font-bold text-lg text-primary-light whitespace-nowrap overflow-hidden animate-fade-in">System</span>}
          <button 
            onClick={toggleSidebar} 
            className={`p-2 rounded-lg text-gray-400 hover:text-white hover:bg-secondary-dark transition-colors ${!isOpen && 'mx-auto'}`}
          >
            {isOpen ? <ChevronLeft className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {/* NAVIGATION LIST */}
        <div className="flex-1 py-4 space-y-2">
          {renderLink(
            'Inicio',
            Home,
            onFilterToggle,
            '/' // Assuming '/' is the dashboard/list view
          )}

          {['admin', 'medico general', 'radiologo', 'radiologiaInterno'].includes(rolUsuario) && (
            renderLink(
              'Plantillas',
              FileText,
              () => onNavigation('/configuration/templates'),
              '/configuration/templates'
            )
          )}

          {rolUsuario === 'admin' && (
            renderLink(
              'Template',
              Layers,
              onToggleTemplate
            )
          )}

          {renderLink(
            'Refrescar',
            RefreshCw,
            () => { window.location.reload(); }
          )}

          {rolUsuario === 'admin' && window.location.protocol === 'http:' && (
            <div className="px-4 py-2">
              <DicomSenderAll isOpen={isOpen} />
            </div>
          )}

          {/* Ocultos según pedido original */}
          <div className="hidden">
            {renderLink(
              'Pacients',
              Users,
              () => onNavigation('/pacients'),
              '/pacients'
            )}
            {renderLink(
              'Appointments',
              Calendar,
              () => onNavigation('/appointments'),
              '/appointments'
            )}
          </div>
        </div>

        {/* BOTTOM FIXED ITEMS */}
        <div className="mt-auto py-4 space-y-2 border-t border-secondary-dark/50">
          {renderLink(
            'Ajustes',
            Settings,
            () => onNavigation('/configuration'),
            '/configuration'
          )}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
